// ---------------------------------------------------------------
// IMPORTS
// ---------------------------------------------------------------
import { log, errorlog } from '../logger/logger';

// ---------------------------------------------------------------
// DEFAULTS
// ---------------------------------------------------------------
let clientConfig = {};

// ---------------------------------------------------------------
// CLASS
// ---------------------------------------------------------------
export class ClientConfig {

    constructor() {}

    init() {
        log('clientConfig init');
        clientConfig = {};
    }

    set(config) {
        set(config);
    }

    get() {
        return get();
    }
}

// ---------------------------------------------------------------
// PRIVATE FUNCTIONS
// ---------------------------------------------------------------
function set(config) {
    clientConfig = config;
}

function get() {
    return clientConfig;
}
